import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useIAPList } from '@/modules/iap/model/list';
import { ROUTE_NAME_SHOP } from '@/modules/shop/router';
import { shopService } from '@/services/shop';
import useVuelidate from '@vuelidate/core';
import { decimal, minValue, required, requiredIf } from '@vuelidate/validators';
import { onMounted, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';

export const ShopItemType = {
    Credit: { value: 1, label: 'Receive the Credit' },
    NoAds: { value: 2, label: 'Remove the Ads' }
};

export const Options = {
    ShopItemType: Object.entries(ShopItemType).map(([, data]) => data)
};

export function useMixins() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { iapOptions, fetchIapOptions } = useIAPList();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        type: null,
        price: null,
        selectedIAP: null,
        packageId: null,
        credit: 0,
        isPublished: false,
        isBestseller: false,
        image: null,
        imageFile: null,
        thumbnail: null,
        thumbnailFile: null,
        canDelete: false,
        canClone: false
    });

    const validations = {
        name: { required },
        type: { required },
        price: { required, decimal, minValue: minValue(0) },
        credit: {
            requiredIf: requiredIf(() => model.type === ShopItemType.Credit.value),
            decimal,
            minValue: minValue(0)
        },
        packageId: { required },
        isPublished: { required },
        isBestseller: { required },
        imageFile: {},
        thumbnailFile: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.id != null,
        request: () => shopService.item.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_SHOP.INDEX })
    });

    const changeIAP = (iapId: number) => {
        iapOptions.value.forEach(item => {
            if (item.value == iapId) {
                model.packageId = item.data.packageId;
                model.price = item.data.price;
            }
        });
    };

    watch(() => model.selectedIAP, changeIAP);

    onMounted(async () => {
        await fetchIapOptions();
        await fetch();
    });

    return { model, v$, fetch, iapOptions };
}
